import type { AxiosInstance } from 'axios';
import type {
	AgendyAisAgendaDto,
	AgendyAisAgendaSeznamDto,
	CiselnikyCiselnikPolozkaDto,
} from '../generated';

export const searchAgendasQuery = async (
	axiosInstance: AxiosInstance,
	text: string | null,
	razeni: 'nazev',
	start = 0
): Promise<AgendyAisAgendaSeznamDto> => {
	const { data } = await axiosInstance.get('/api/v1/agendy', {
		params: {
			text,
			razeni,
			start,
		},
	});
	return data;
};

export const agendasQuery = async (
	axiosInstance: AxiosInstance
): Promise<{
	seznam?: AgendyAisAgendaDto[];
}> => {
	const { data } = await axiosInstance.get('/api/v1/agendy');
	return data;
};

export const ovmAgendasQuery = async (
	axiosInstance: AxiosInstance,
	kodOvm: string,
	maUdaje?: boolean,
	pusobnost?: boolean
): Promise<AgendyAisAgendaSeznamDto> => {
	const { data } = await axiosInstance.get(`/api/v1/ovm/${kodOvm}/agendy`, {
		params: {
			...(maUdaje ? { maUdaje } : {}),
			...(pusobnost ? { pusobnost } : {}),
		},
	});
	return data;
};

export interface CiselnikyCiselnikPolozkaDtoAgendaData extends CiselnikyCiselnikPolozkaDto {
	parametry: {
		adresaText?: string;
	};
}

export const agendasCiselnikyQuery = async (
	axiosInstance: AxiosInstance,
	kod: string
): Promise<{
	seznam?: CiselnikyCiselnikPolozkaDtoAgendaData[];
}> => {
	const { data } = await axiosInstance.get(
		`/api/v1/ciselniky/UDAJE_AGENDY_${kod}/polozky`
	);
	return data;
};
